import { render } from "./ProjectPage.vue?vue&type=template&id=2e9fd2e6"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__